import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as reactOnclickoutside_es from '../node_modules/react-onclickoutside/dist/react-onclickoutside.es.js';

var require$$59 = /*@__PURE__*/getAugmentedNamespace(reactOnclickoutside_es);

export { require$$59 as default };
